export const AUTOSAVE_INTERVAL = 10000;
export const NONE = "none";
export const BANK_DEPOSIT = "BANK DEPOSIT";
export const PAYMENT_LINK = "PAYMENT LINK";
